import { ImageTag, SpanTag } from "@tm/ui-widgets/components";
import { theme } from "@tm/utility/global";
import { TagItem, TagsStyle } from "./Tags.style";

interface TagsProps {
  handleClickTab?: (index?: string | number) => void;
  data: {
    id?: number | string;
    name?: string;
    isSelected?: boolean;
    tagImg?: string;
  }[];
}

const Tags = ({ data, handleClickTab }: TagsProps) => {
  return (
    <TagsStyle>
      {data?.map((item) => {
        return (
          <>
            <TagItem
              isSelected={item.isSelected}
              onClick={
                handleClickTab ? () => handleClickTab(item.id) : () => {}
              }
              key={item.id}
            >
              <SpanTag
                color={item.isSelected ? theme.blueText : theme.greyText}
                fontSize="xs"
                fontWeight="black"
              >
                {item.name}
              </SpanTag>
              {item.tagImg && (
                <ImageTag src={item.tagImg} width="30px" height="14px" />
              )}
            </TagItem>
          </>
        );
      })}
    </TagsStyle>
  );
};

export default Tags;
